import {number} from 'yup'
import {REACT_APP_API_ACCOUNTS} from '../config'
import axios from './interceptors/axios.global'

const authControllers = 'AuthControllers'
const admin = 'Admin'
const user = 'User'

const create = async (data: any) => {
  return axios.post(`${REACT_APP_API_ACCOUNTS}/${authControllers}/Register`, data)
}

const getById = (id: string) => {
  return axios.get(`${REACT_APP_API_ACCOUNTS}/${admin}/GetUserById?userId=${id}`)
}

const update = (data: any) => {
  return axios.put(`${REACT_APP_API_ACCOUNTS}/${admin}/UpdateUserinfo`, data)
}

const getProfile = (id: string) => {
  if (id != '' && id != '0' && id != 'undefined' && id != 'null')
    return axios.get(`${REACT_APP_API_ACCOUNTS}/${admin}/GetUserById?userId=${id}`)
  else return axios.get(`${REACT_APP_API_ACCOUNTS}/${user}/GetProfile`)
  // return axios.get(`${REACT_APP_API_ACCOUNTS}/${user}/GetProfile`);
}

const getUser = (emailOrPhoneNumber: string) => {
  // console.log('emailOrPhoneNumber in account service:', emailOrPhoneNumber)
  return axios.get(`${REACT_APP_API_ACCOUNTS}/${admin}/GetUser?parameter=${emailOrPhoneNumber}`)
}

const getAll = (PageNumber: number, PageSize: number) => {
  return axios.get(
    `${REACT_APP_API_ACCOUNTS}/${admin}/GetAllUsersPaged?PageNumber=${PageNumber}&PageSize=${PageSize}`
  )
}

// curl -X POST "https://accounts.tygo.net:443/api/Admin/AddUserBulk" -H  "accept: text/plain" -H  "Authorization: Bearer eyJhbGciOiJodHRwOi8vd3d3LnczLm9yZy8yMDAxLzA0L3htbGRzaWctbW9yZSNobWFjLXNoYTI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1laWRlbnRpZmllciI6IjUzMWQzNmE0LWJmZmUtNGFlMC04NWJjLTZlMDliYzJmMGJiMiIsIkRldmljZVR5cGUiOiJXZWIiLCJuYmYiOiIxNjY1MzI1MzA1IiwiZXhwIjoiMTY2NzkxNzMwNSIsImlzcyI6Imh0dHBzOi8vbG9jYWxob3N0OjUwMDEiLCJhdWQiOiJUYXlnb0FwaSIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IkFkbWluIn0.nhQ-fPhEJFKqEhwLL0FRuZE6ROyBU4LvA-EnTW5clJ4" -H  "Content-Type: application/json" -d "[{\"firstName\":\"string\",\"lastName\":\"string\",\"dateOfBirth\":\"2022-10-11T17:20:25.946Z\",\"createdAt\":\"2022-10-11T17:20:25.946Z\",\"deviceToken\":\"string\",\"deviceType\":\"Notconifrm\",\"gander\":\"Male\",\"phoneNumberConfirmed\":true,\"phoneNumber\":\"string\",\"countryCode\":\"string\",\"emailConfirmed\":true,\"email\":\"string\"}]"
const addUserBulk = async (data: any) => {
  // lowercase and check if it is == 'true' or 'false'
  data.forEach((item: any) => {
    item.phoneNumberConfirmed = item.phoneNumberConfirmed.toString().toLowerCase() == 'true'
    item.emailConfirmed = item.emailConfirmed.toString().toLowerCase() == 'true'
  })

  // data.phoneNumberConfirmed = data.phoneNumberConfirmed.tolower().trim() === 'true';
  return axios.post(`${REACT_APP_API_ACCOUNTS}/${admin}/AddUserBulk`, data, {
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

const delete_ = (id: number) => {
  return axios.delete(`${REACT_APP_API_ACCOUNTS}/${user}/${id}`)
}

// Authorities Calls
const GetRolesAndUsersIds = (PageSize?: number, PageNumber?: number) => {
  return axios.get(
    `${REACT_APP_API_ACCOUNTS}/${admin}/GetRolesAndUsersIds?PageSize=${PageSize}&PageNumber=${PageNumber}`
  )
}

const AssignRoleToUser = (userId: string, roleName: string) => {
  return axios.post(
    `${REACT_APP_API_ACCOUNTS}/${admin}/AssignRoleToUser?userId=${userId}&roleName=${roleName}`
  )
}

const RemoveUserFromRole = (userId: string, roleName: string) => {
  return axios.post(
    `${REACT_APP_API_ACCOUNTS}/${admin}/RemoveUserFromRole?userId=${userId}&roleName=${roleName}`
  )
}

const AddNewRole = (roleName: string) => {
  return axios.post(`${REACT_APP_API_ACCOUNTS}/${admin}/AddNewRole?roleName=${roleName}`)
}

const GetRoles = () => {
  return axios.get(`${REACT_APP_API_ACCOUNTS}/${admin}/GetRoles`)
}

// http://test.accounts.tygo.net:443/api/Admin/BlackListUser
const BlackListUser = (userId: string) => {
  return axios.put(`${REACT_APP_API_ACCOUNTS}/${admin}/BlackListUser?userId=${userId}`)
}

// http://test.accounts.tygo.net:443/api/Admin/UnBlackListUser
const UnBlackListUser = (userId: string) => {
  return axios.put(`${REACT_APP_API_ACCOUNTS}/${admin}/UnBlackListUser?userId=${userId}`)
}

const AccountService = {
  create,
  update,
  delete: delete_,
  getAll,
  getById,
  getProfile,
  addUserBulk,
  getUser,
  GetRolesAndUsersIds,
  AssignRoleToUser,
  RemoveUserFromRole,
  AddNewRole,
  GetRoles,
  BlackListUser,
  UnBlackListUser,
}
export default AccountService
